import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = {
  request: {
    isPending: false,
    isSuccessful: false,
    isFailure: false,
  },
  links: [],
};

function handleRequest(state: State): State {
  return { ...state, request: setRequestStateToPending() };
}

function handleSuccess(
  state: State,
  links: Boundaries["retrieveCalendarExportLinks"]["success"],
): State {
  return { ...state, request: setRequestStateToSuccess(), links };
}

function handleFailure(state: State): State {
  return { ...state, request: setRequestStateToFailure() };
}

function handleCreateCalendarExportLink(
  state: State,
  { link }: Boundaries["createCalendarExportLink"]["success"],
): State {
  return {
    ...state,
    request: setRequestStateToFailure(),
    links: [...state.links, link],
  };
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.retrieveCalendarExportLinksRequested]: handleRequest,
    [events.retrieveCalendarExportLinksSucceeded]: handleSuccess,
    [events.retrieveCalendarExportLinksFailed]: handleFailure,
    [events.createCalendarExportLinkSucceeded]: handleCreateCalendarExportLink,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
